<template>
  <div class="live-commentary-text">
    <p v-if="data.commentaryType === 2">
      <span class="live-commentary-text-text">{{ data.commentaryText.message }}</span>
      <span
        v-if="data.commentaryText.iconTitle"
        class="live-commentary-text-icon"
        :class="{
          gray: data.commentaryText.iconType === 3
        }"
        @click="handleClickTag"
      >{{ data.commentaryText.iconTitle }}</span>
    </p>
    <p
      v-if="data.commentaryType === 1"
      :class="['live-commentary-text-text',{
        'high-light':data.commentaryText.eventType === 28
      }]"
      v-html="message"
    />

    <!-- 弹窗 -->
    <DialogWidget
      v-model="visible"
      :widget="data.commentaryText.iconWidget"
      :event-id="event.eventId"
      :sport-id="event.sportId"
    />
  </div>
</template>

<script>
import { storeToRefs } from 'pinia'
import { useMatchDetailStore } from 'wap/stores/matchDetail'
import DialogWidget from 'base/components/Widgets/DialogWidget.vue'

export default {
  name: 'MsgText',
  components: {
    DialogWidget
  },
  inheritAttrs: false, // 不回退defaultMarkets为 attr
  props: {
    needHighlight: {
      // 是否需要整条高亮显示
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  setup() {
    const matchDetailStore = useMatchDetailStore()
    const { event } = storeToRefs(matchDetailStore)

    return {
      event
    }
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    message() {
      let { message, player } = this.data.commentaryText
      message = message.replace(/</g, '&lt;').replace(/>/g, '&gt;')
      if (player) {
        const replaceReg = new RegExp(`(${player})`, 'gi')
        return message.replace(replaceReg, '<span class="keyWord">$1</span>')
      } else {
        return message
      }
    }
  },
  methods: {
    handleClickTag() {
      const { commentaryText } = this.data
      switch (commentaryText.iconType) {
        // widget
        case 1:
          this.visible = true
          break
        // url
        case 2:
          return window.open(commentaryText.iconUrl)
        case 3:
          return false
        default:
        // no default
      }
    }
  }
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.live-commentary-text {
  line-height: 1.6;

  &-text {
    color: @white;
    font-size: 14/@rem;

    &.high-light {
      font-weight: bold;
    }

    .keyWord {
      font-weight: bold;
    }
  }

  &-icon {
    display: inline-block;
    height: 16/@rem;
    padding: 0 10/@rem;
    border-radius: 16/@rem;
    background-color: @primary;
    color: @major;
    font-size: 10/@rem;
    line-height: 16/@rem;
    white-space: nowrap;

    &.gray {
      background: #999;
    }
  }
}
</style>
